import * as React from 'react';
import FilePickerAction from '../store/schema/FilePickerAction';
import strings from 'owa-strings/owa-mail-strings';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

const styles = require('./FilePickerPaneBottomPart.scss');

export interface FilePickerPaneBottomPartProps {
    supportedActions: FilePickerAction[];
    onNextClicked: () => void;
    onCancelClicked: () => void;
}

@observer
export default class FilePickerPaneBottomPart extends React.Component<
    FilePickerPaneBottomPartProps,
    {}
> {
    render() {
        const disableNextButton =
            !this.props.supportedActions || this.props.supportedActions.length == 0;

        return (
            <div className={styles.container}>
                <div className={styles.buttonContainer}>
                    <PrimaryButton
                        className={styles.button}
                        disabled={disableNextButton}
                        ariaLabel={strings.NextText}
                        onClick={() => {
                            this.props.onNextClicked();
                        }}>
                        {strings.NextText}
                    </PrimaryButton>

                    <span className={styles.cancelButtonContainer}>
                        <DefaultButton
                            className={styles.button}
                            ariaLabel={strings.CancelText}
                            onClick={this.props.onCancelClicked}>
                            {strings.CancelText}
                        </DefaultButton>
                    </span>
                </div>
            </div>
        );
    }
}
